var render = function render(){var _vm=this,_c=_vm._self._c;return _c('typo',{staticClass:"badge",attrs:{"name":`${_vm.fontSize || 'body-14-light'}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }